/**
 * Check mark for the success state — Figma node `20188:57871`, exported
 * verbatim (42 x 42 in a 96 container).
 *
 * `strokeDasharray="1.17 1.17"` comes straight out of the Figma export and
 * looks like a mistake, but it renders solid: the stroke is 3.5 wide with round
 * caps, so every 1.17 gap is more than bridged by the caps either side. Kept
 * as-is rather than "cleaned up", so the asset stays faithful to the source.
 */
export function CheckGlyph({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 42 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
    >
      <path
        d="M9.33333 21L17.5 29.1667L32.6667 12.8333"
        stroke="white"
        strokeWidth="3.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeDasharray="1.17 1.17"
      />
    </svg>
  );
}
